import { createSelector } from "reselect";
import { isEmpty } from "lodash";

const getProteinAtlasData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.protein_atlas
    : state?.variantResult?.protein_atlas;
};

const getHPATopProteinExpression = createSelector(
  getProteinAtlasData,
  (data) => {
    if (isEmpty(data)) return null;
    const { pathology_info: pathologyInfoData } = data;

    const pathologyData = pathologyInfoData.map((x) => {
      const total =
        Number(x.high_risk) +
        Number(x.low_risk) +
        Number(x.medium_risk) +
        Number(x.not_detected);
      const totalHighMedium = Number(x.high_risk) + Number(x.medium_risk);
      const value = total !== 0 ? (totalHighMedium / total) * 100 : 0;
      const name = x.cancer_name;
      return {
        name,
        value,
      };
    });

    const filteredPathologyData = pathologyData.filter((x) => x.value !== 0);
    if (filteredPathologyData.length === 0) return null;

    const sortedDataUsingHighestValue = filteredPathologyData.sort(
      (a, b) => b.value - a.value
    );

    const countOccurencyOfHighestValue = sortedDataUsingHighestValue.filter(
      (obj) => obj.value === sortedDataUsingHighestValue[0].value
    ).length;

    const topProteinExpression = {
      name: sortedDataUsingHighestValue[0].name,
      value: sortedDataUsingHighestValue[0].value,
      occurrences: countOccurencyOfHighestValue,
    };

    return topProteinExpression;
  }
);

const getTissuesDetectedLength = createSelector(getProteinAtlasData, (data) => {
  const tissuesDetected = data?.tissue_info?.filter((x) => {
    return x.level !== "Not detected";
  });
  return tissuesDetected?.length || null;
});

export {
  getProteinAtlasData,
  getHPATopProteinExpression,
  getTissuesDetectedLength,
};
